const getters={
  getNotifications: (state) => state.notifications,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/modules/notifications/getters.js